import { Flex } from 'antd'
import { createUseStyles } from 'react-jss'
import { useIsAdmin } from '../../../redux/slices/session'
import { ListError, PageHeader } from '../../Common'
import CyclesFilter from '../../Common/CyclesFilter'
import usePracticeCycles from '../../Common/usePracticeCycles'
import Filters, { FIELDS_OPTIONS } from '../../Forms/Filters'
import { PAGE_SIZE } from '../../../lib/constants'
import { useIsMobile } from '../../../hooks'
import { MOBILE_MEDIA_QUERY } from '../../../lib/responsive'
import useFilters from '../../Cycles/useFilters'
import BillingOrders from './BillingOrders'

const DEFAULT_FILTERS = {
  query: '',
  page: 1,
  perPage: PAGE_SIZE,
  billed: FIELDS_OPTIONS.billed[0].id,
  showInactive: false,
}

const useStyles = createUseStyles({
  // On mobile the cycle picker gets a line of its own, so stretch it: antd
  // Selects size to their content and would otherwise leave the row half empty.
  cycleFilter: {
    [MOBILE_MEDIA_QUERY]: {
      '& .ant-form-item': {
        width: '100%',
        margin: 0,
      },
      '& .ant-select': {
        width: '100% !important',
      },
    },
  },
})

export default function PracticeBillingOrders() {
  const isAdmin = useIsAdmin()
  const isMobile = useIsMobile()
  const classes = useStyles()
  const [
    { error, pendingCycles, clearError },
    { practice, pending, practiceId },
  ] = usePracticeCycles()

  const {
    handleFilterChange,
    handlePageChange,
    conditions,
    setConditions,
  } = useFilters(DEFAULT_FILTERS, { defaultToPrevCycle: 'always' })

  const { cycleId, page, query, billed, showInactive } = conditions

  if (cycleId && !pending && !pendingCycles) {
    const cyclesEl = (
      <CyclesFilter
        practiceId={practiceId}
        onSubmit={({ cycleId: newCycleId }) =>
          handleFilterChange({ cycleId: newCycleId })
        }
        currentCycleId={cycleId}
      />
    )

    const filtersEl = (
      <Filters
        defaultValues={DEFAULT_FILTERS}
        currentValues={conditions}
        onSubmit={({
          query: newQuery,
          billed: newBilled,
          showInactive: newShowInactive,
        }) =>
          setConditions({
            ...conditions,
            query: newQuery,
            billed: newBilled,
            showInactive: newShowInactive || undefined,
            page: 1,
          })
        }
        placeholders={{
          query: 'Search by Name, DOB(YYYY-MM-DD), or MRN',
          billed: 'Billed status',
        }}
        showSearch
        showBilledStatus
        showInactiveCheck
      />
    )

    return (
      <div>
        <PageHeader
          title="Remote Billing Orders"
          subTitle={isAdmin && practice.name}
          hideSubTitleOnMobile
        />
        {/* The cycle picker and the filters don't fit on one narrow line. On
            mobile they are also rendered as siblings rather than inside the
            Flex, so the sticky filters bar keeps the tall page container as its
            positioning parent. */}
        {isMobile ? (
          <>
            <div className={classes.cycleFilter}>{cyclesEl}</div>
            {filtersEl}
          </>
        ) : (
          <Flex gap={10}>
            {cyclesEl}
            {filtersEl}
          </Flex>
        )}
        <BillingOrders
          cycleId={cycleId}
          onPageChange={handlePageChange}
          page={page}
          query={query}
          billed={billed}
          showInactive={showInactive}
          practiceId={practiceId}
        />
      </div>
    )
  }

  return (
    <div>
      {error && <ListError description={error.message} onClose={clearError} />}
    </div>
  )
}
